import React from 'react';

const StatsCard = ({ 
    title, 
    value, 
    change, 
    changeType = 'positive', 
    icon, 
    color = 'blue',
    loading = false,
    onClick 
}) => {
    const colorClasses = {
        blue: 'bg-blue-50 text-blue-600',
        green: 'bg-green-50 text-green-600',
        red: 'bg-red-50 text-red-600',
        yellow: 'bg-yellow-50 text-yellow-600',
        purple: 'bg-purple-50 text-purple-600',
        indigo: 'bg-indigo-50 text-indigo-600',
        pink: 'bg-pink-50 text-pink-600',
        gray: 'bg-gray-50 text-gray-600'
    };

    const changeColorClasses = {
        positive: 'text-green-600 bg-green-50',
        negative: 'text-red-600 bg-red-50',
        neutral: 'text-gray-600 bg-gray-50'
    };

    if (loading) {
        return (
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 animate-pulse">
                <div className="flex items-center justify-between">
                    <div className="flex items-center space-x-3">
                        <div className="w-12 h-12 bg-gray-200 rounded-xl"></div>
                        <div>
                            <div className="h-4 bg-gray-200 rounded w-24 mb-2"></div>
                            <div className="h-6 bg-gray-200 rounded w-16"></div>
                        </div>
                    </div>
                    <div className="h-6 bg-gray-200 rounded w-16"></div>
                </div>
            </div>
        );
    }

    return (
        <div 
            className={`bg-white rounded-xl shadow-sm border border-gray-200 p-6 hover:shadow-md transition-all duration-200 ${
                onClick ? 'cursor-pointer hover:scale-105' : ''
            }`}
            onClick={onClick}
        >
            <div className="flex items-center justify-between">
                <div className="flex items-center space-x-3">
                    <div className={`w-12 h-12 rounded-xl flex items-center justify-center ${colorClasses[color]}`}>
                        <span className="text-xl">{icon}</span>
                    </div>
                    <div>
                        <p className="text-sm font-medium text-gray-600">{title}</p>
                        <p className="text-2xl font-bold text-gray-900">{value}</p>
                    </div>
                </div>
                
                {change !== undefined && (
                    <div className={`px-2 py-1 rounded-full text-xs font-medium ${changeColorClasses[changeType]}`}>
                        {changeType === 'positive' && '+'}
                        {change}
                        {typeof change === 'number' && '%'}
                    </div>
                )}
            </div>
        </div>
    );
};

export default StatsCard;





